import React, { Component } from 'react';
import '../../../styles/scss/style.css';

//Components
import SectionDivider from '../molecules/SectionDivider';

//Returning the component
class DeactivateAccount extends Component {
	render() {
		return (
			<div className="deactivateAccount margin-b-md">
				<SectionDivider heading="Deactivate account" />
				<div dangerouslySetInnerHTML={{ __html: '<p class="textParagraph color-accent1">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritat. <a class="textAnchor color-primary" href="#clicked">Deactivate my account</a>.</p>' }} />
			</div>
		)
	}
}

export default DeactivateAccount;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/DeactivateAccount.jsx